import { startOfDay, addDays, format, parse } from "date-fns";
export var DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
export var DEFAULT_URL_DATE_FORMAT = "MM-dd-yyyy";
export var formatDate = function (date, dateFormat) {
    if (dateFormat === void 0) { dateFormat = DEFAULT_DATE_FORMAT; }
    return date ? format(date, dateFormat) : "mm/dd/yyyy";
};
export var formatURLDate = function (date) {
    return formatDate(date, DEFAULT_URL_DATE_FORMAT);
};
export var parseDate = function (date, format) {
    if (format === void 0) { format = DEFAULT_DATE_FORMAT; }
    return date instanceof Date
        ? date
        : date
            ? parse(date, format, new Date())
            : new Date();
};
export var parseURLDate = function (date) {
    return date instanceof Date
        ? date
        : date
            ? date === "today"
                ? startOfDay(new Date())
                : date === "tomorrow"
                    ? addDays(startOfDay(new Date()), 1)
                    : parse(date, DEFAULT_URL_DATE_FORMAT, new Date())
            : new Date();
};
